<template>
  <div class="map-wrapper">
    <!-- 地図 -->
    <div id="google-map" :class="{ visible: mapVisible }"></div>
    <!-- マーカーなどGoogleMapsAPIを利用するコンポーネント -->
    <template v-if="Boolean(this.google) && Boolean(this.map)">
      <slot />
    </template>
  </div>
</template>

<script>
import { mapActions } from "vuex";
import GoogleMapsApiLoader from "google-maps-api-loader";
import Landmark from "@/mixins/landmark.js";

export default {
  mixins: [Landmark],

  props: {
    mapVisible: Boolean,
  },

  data() {
    return {
      google: null,
      map: null,
      currentPaddyFieldId: null,
    };
  },

  computed: {
    // TODO 定数定義、外部設定化
    mapApiParams() {
      return {
        key: "AIzaSyBFy7QIpKgbajQzUxHLvkM1FphT9jPO7NU",
        libraries: ["drawing"],
        v: "3.39",
      };
    },
    // TODO 地域マスタからcenterを設定する
    mapConfig() {
      return {
        center: {
          lat: 38.8484113,
          lng: 139.8773358,
        },
        disableDefaultUI: true,
        zoomControl: true,
        zoomControlOptions: {
          position: this.google.maps.ControlPosition.RIGHT_BOTTOM,
        },
        zoom: 17,
        mapTypeControl: true,
        mapTypeControlOptions: {
          position: this.google.maps.ControlPosition.LEFT_BOTTOM,
        },
        mapTypeId: "satellite",
      };
    },
  },

  async mounted() {
    // アカウント情報から中心座標を取得する
    const aid = await this.showAccountID();
    const ac = await this.showAccount(aid);

    // 中心座標が設定済みか
    let areaPosExists = false;
    if (ac["area_pos"] && ac["area_pos"].latitude && ac["area_pos"].longitude) {
      areaPosExists = true;
    }

    let confCenter;
    if (areaPosExists) {
      confCenter = {
        lat: parseFloat(ac["area_pos"].latitude),
        lng: parseFloat(ac["area_pos"].longitude),
      };
    } else {
      // 中心座標未指定（初期状態）の場合の仮位置とズームレベル
      confCenter = {
        lat: 36.0,
        lng: 138.0,
        zoom: 5,
      };
    }

    const googleMapApi = await GoogleMapsApiLoader({
      libraries: this.mapApiParams.libraries,
      version: this.mapApiParams.v,
      apiKey: this.mapApiParams.key,
    });
    this.google = googleMapApi;
    this.setGoogle(this.google);
    this.initializeMap(confCenter);

    this.updateAreaName("");
    if (areaPosExists) {
      // 中心座標が設定済みの場合のみ住所を更新
      this.geocodeHome(confCenter);
    }

    if (areaPosExists) {
      // 中心位置（住所）のマーカー設定
      const { Marker } = this.google.maps;
      const marker = new Marker({
        position: { lat: confCenter.lat, lng: confCenter.lng },
        map: this.map,
      });
      let iconProps = { url: require("@/assets/icons/ic_home.png") };
      iconProps = Object.assign(iconProps, {
        scaledSize: { width: 42, height: 56 },
      });
      marker.setIcon(iconProps);
      this.setHomeMarker(marker);
    } else {
      this.setHomeMarker(null);
    }

    if (this.$route.name !== "landmarks") {
      // ランドマーク表示
      // 以下はランドマーク設定画面と二重で処理してしまうとマーカーが重複するため回避する
      await this.retrieveLandmarks();
      const landmarkMarkers = [];
      this.putLandmarkMarkers((marker) => {
        landmarkMarkers.push(marker);
      });
      this.setLandmarkMarkers(landmarkMarkers);
    }

    this.$emit("mapMounted");
  },

  methods: {
    ...mapActions([
      "setGoogle",
      "setMap",
      "setHomeMarker",
      "showAccount",
      "showAccountID",
      "updateAreaName",
      "retrieveLandmarks",
      "setLandmarkMarkers",
    ]),

    initializeMap(confCenter) {
      const mapContainer = this.$el.querySelector("#google-map");
      let conf = this.mapConfig;
      conf["center"] = confCenter;
      if (confCenter.zoom) {
        conf["zoom"] = confCenter.zoom;
      }
      this.map = new this.google.maps.Map(mapContainer, conf);
      this.map.setTilt(0);
      this.setMap(this.map);
    },

    geocodeHome(confCenter) {
      // Geocoderを使用して、住所を取得する
      const geocoder = new this.google.maps.Geocoder();
      const latlng = {
        lat: confCenter.lat,
        lng: confCenter.lng,
      };
      geocoder.geocode({ location: latlng }, (results, status) => {
        if (status == this.google.maps.GeocoderStatus.OK) {
          if (results[0]) {
            let areaInfo = {
              locality: null,
              area2: null,
              area1: null,
            };
            const address = results[0].address_components;
            if (address) {
              address.forEach((item) => {
                if (item.types) {
                  if (item.types.indexOf("locality") >= 0) {
                    areaInfo.locality = item.short_name;
                  }
                  if (item.types.indexOf("administrative_area_level_2") >= 0) {
                    areaInfo.area2 = item.short_name;
                  }
                  if (item.types.indexOf("administrative_area_level_1") >= 0) {
                    areaInfo.area1 = item.short_name;
                  }
                }
              });
            }
            if (areaInfo.locality) {
              this.updateAreaName(areaInfo.locality);
            } else if (areaInfo.area2) {
              this.updateAreaName(areaInfo.area2);
            } else if (areaInfo.area1) {
              this.updateAreaName(areaInfo.area1);
            }
          } else {
            console.log("Geocoder No results found");
          }
        } else {
          console.log("Geocoder failed due to: " + status);
        }
      });
    },
  },
};
</script>

<style lang="scss">
.map-wrapper {
  position: relative;
}
// #map {
#google-map {
  width: 100%;
  min-height: 100vh;
  display: none;
  &.visible {
    display: block;
  }
}
</style>
